import { useState } from 'react';
import { ACCENT, CONTEXT, GRID, GROUND, INK, INK_MUTED } from './palette';

/** Slope chart — public cloud as the primary home for production inference, before → now. */

const W = 520;
const H = 200;
const PAD_X = 60;
const PAD_Y = 30;

const series = [
  { label: 'Before', value: 56 },
  { label: 'Now', value: 41 },
];

const y = (value: number) => H - PAD_Y - (value / 70) * (H - PAD_Y * 2);

export function InferenceShiftChart() {
  const [hovered, setHovered] = useState<number | null>(null);
  const xs = [PAD_X, W - PAD_X];

  return (
    <figure className="m-0">
      <svg viewBox={`0 0 ${W} ${H}`} className="h-auto w-full" role="img" aria-label="Share of enterprises using public cloud as the primary environment for production AI inference: 56 percent before, 41 percent now">
        {[0, 20, 40, 60].map((g) => (
          <g key={g}>
            <line x1={PAD_X - 20} x2={W - PAD_X + 20} y1={y(g)} y2={y(g)} stroke={GRID} strokeWidth="1" strokeDasharray={g === 0 ? undefined : '2 4'} />
            <text x={PAD_X - 28} y={y(g) + 4} textAnchor="end" fontSize="10" fill={INK_MUTED} fontFamily="IBM Plex Mono, monospace">
              {g}%
            </text>
          </g>
        ))}
        <line x1={xs[0]} y1={y(series[0].value)} x2={xs[1]} y2={y(series[1].value)} stroke={ACCENT} strokeWidth="2" strokeLinecap="round" />
        {series.map((p, i) => (
          <g key={p.label} onMouseEnter={() => setHovered(i)} onMouseLeave={() => setHovered(null)} style={{ cursor: 'default' }}>
            <rect x={xs[i] - 34} y={0} width={68} height={H} fill="transparent" />
            <circle cx={xs[i]} cy={y(p.value)} r={hovered === i ? 7 : 5} fill={ACCENT} stroke={GROUND} strokeWidth="2" style={{ transition: 'r 150ms' }} />
            <text x={xs[i]} y={y(p.value) - 16} textAnchor="middle" fontSize="20" fontWeight="600" fill={INK} fontFamily="IBM Plex Mono, monospace">
              {p.value}%
            </text>
            <text x={xs[i]} y={H - 6} textAnchor="middle" fontSize="11" fill={INK_MUTED} fontFamily="IBM Plex Mono, monospace">
              {p.label}
            </text>
          </g>
        ))}
        <text x={(xs[0] + xs[1]) / 2} y={y((series[0].value + series[1].value) / 2) - 10} textAnchor="middle" fontSize="12" fontWeight="600" fill={CONTEXT} fontFamily="IBM Plex Mono, monospace">
          −15 points
        </text>
      </svg>
      <figcaption className="mt-3 text-[11px] leading-relaxed text-ink-3">
        Share of enterprises using public cloud as the primary environment for production AI inference. Over the same period around 56% now run or plan
        inference on private infrastructure — the migration Fnk is built for.
      </figcaption>
    </figure>
  );
}
